'use client';

import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useParams } from 'next/navigation';
import { pdpProgressReportOptions } from '@/api/queries/pdpProgressReport';
import { MetaDataParams, PdpProgressReportDTO } from '@/types/models';
export function usePdpProgressReport(): UseQueryResult<PdpProgressReportDTO[] | undefined> {
  const params = useParams<MetaDataParams>();
  const id = params.slug?.[0] || params.id;
  return useQuery(pdpProgressReportOptions(id as string));
}